const Contact = () => {
	return (
		<div className="ml-8 mr-8 md:ml-40 md:mr-40 border-t-2 p-4 justify-center items-center">
			<h1 className="">Feel free to email me about anything!</h1>
			<h1>Email: zhiyaoyu19@gmail.com</h1>
		</div>
	)
}

export default Contact